import React from "react";

const AnnouncementBanner = () => {
  return (
    <div
      className="relative w-full bg-[#F2f2f2] py-3 border-b border-gray-200 overflow-hidden flex whitespace-nowrap"
    >
      <div className="animate-marquee flex shrink-0 items-center">
        <p className="text-[#222222] font-inter font-bold text-xs md:text-sm uppercase tracking-wider px-8">
          ⚽ Academy Trials are STARTING!
          <span className="text-gray-600 font-medium ml-2">
            | Register via Interest Form
          </span>
        </p>
        <p className="text-[#222222] font-inter font-bold text-xs md:text-sm uppercase tracking-wider px-8">
          ⚽ New Season Registrations is OPEN!
          <span className="text-gray-600 font-medium ml-2">
            | Limited spots available
          </span>
        </p>

        <p className="text-[#222222] font-inter font-bold text-xs md:text-sm uppercase tracking-wider px-8">
          ⚽ Academy Trials are STARTING!
          <span className="text-gray-600 font-medium ml-2">
            | Register via Interest Form
          </span>
        </p>
        <p className="text-[#222222] font-inter font-bold text-xs md:text-sm uppercase tracking-wider px-8">
          ⚽ New Season Registrations is OPEN!
          <span className="text-gray-600 font-medium ml-2">
            | Limited spots available
          </span>
        </p>
      </div>
    </div>
  );
};

export default AnnouncementBanner;
